/**
 * Отрезки линии между разрывами: каждый — индексы подряд идущих точек
 * с числом. Чистая, чтобы проверять числами.
 */
export function lineSegments(data: readonly (number | null)[]): number[][] {
  const out: number[][] = [];
  let cur: number[] = [];
  data.forEach((v, i) => {
    if (v == null || !Number.isFinite(v)) {
      if (cur.length) out.push(cur);
      cur = [];
    } else {
      cur.push(i);
    }
  });
  if (cur.length) out.push(cur);
  return out;
}
